// import { Button, Select, Card, Typography, Space } from "antd";
// import React, { useState, useEffect } from "react";
// import AboutElectionsUpload from "./AboutElectionsUpload";
// import dataService from "../../networks/api/service/dataService";

// const { Option } = Select;
// const { Title } = Typography;

// function AboutAssembly() {
//   const [constituencyList, setConstituencyList] = useState([]);
//   const [assemblyList, setAssemblyList] = useState([]);
//   const [constituencyId, setConstituencyId] = useState("");
//   const [assemblyId, setAssemblyId] = useState("");
//   const [extractedData, setExtractedData] = useState(null);

//   const OnAssemblySelect = (value) => {
//     setAssemblyId(value);
//   };

//   const OnConstituencySelect = async (value) => {
//     setConstituencyId(value);
//     setAssemblyId("");
//     setAssemblyList([]);
//     try {
//       const res = await dataService.getAssemblyFromConstituency(value);
//       if (res.code === 200) setAssemblyList(res.data);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const handleFileData = (data) => {
//     setExtractedData(data);
//   };

//   const handleSubmit = () => {
//     if (!assemblyId || !constituencyId || !extractedData) {
//       alert("Please select all fields and upload a file");
//       return;
//     }

//     const payload = {
//       assemblyId,
//       constituencyId,
//       geographicalArea: extractedData.geographicalArea,
//       electedCandidate: extractedData.electedCandidate,
//     };

//     console.log("Final Payload:", payload);
//   };

//   const getConstituency = async () => {
//     try {
//       const res = await dataService.getAllConstituency();
//       if (res.code === 200) setConstituencyList(res.data);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   useEffect(() => {
//     getConstituency();
//   }, []);

//   return (
//     <Card
//       title={<Title level={4}>About Assembly Elections</Title>}
//       style={{ width: "100%", maxWidth: 600, margin: "auto", padding: 20 }}
//     >
//       <Space direction="vertical" size="middle" style={{ width: "100%" }}>
//         <Select
//           value={constituencyId}
//           showSearch
//           optionFilterProp="children"
//           filterOption={(input, option) =>
//             option?.children?.toLowerCase().includes(input.toLowerCase())
//           }
//           placeholder="Select Parliament"
//           style={{ width: "100%" }}
//           onChange={OnConstituencySelect}
//         >
//           <Option key={827272} value="" disabled>
//             Select Parliament
//           </Option>
//           {constituencyList.map((item) => (
//             <Option key={item._id} value={item._id}>
//               {item.constituencyName}
//             </Option>
//           ))}
//         </Select>

//         <Select
//           value={assemblyId}
//           showSearch
//           optionFilterProp="children"
//           filterOption={(input, option) =>
//             option?.children?.toLowerCase().includes(input.toLowerCase())
//           }
//           placeholder="Select Assembly"
//           style={{ width: "100%" }}
//           onChange={OnAssemblySelect}
//         >
//           <Option key={827272} value="" disabled>
//             Select Assembly
//           </Option>
//           {assemblyList.map((item) => (
//             <Option key={item._id} value={item._id}>
//               {item.assemblyName}
//             </Option>
//           ))}
//         </Select>

//         <AboutElectionsUpload onDataExtracted={handleFileData} />

//         <Button type="primary" onClick={handleSubmit} block>
//           Submit
//         </Button>
//       </Space>
//     </Card>
//   );
// }

// export default AboutAssembly;

import { Button, Select, Card, Typography, Space, Form, message } from "antd";
import React, { useState, useEffect } from "react";
import AboutElectionsUpload from "./AboutElectionsUpload";
import dataService from "../../networks/api/service/dataService";

const { Option } = Select;
const { Title } = Typography;

function AboutAssembly() {
  const [constituencyList, setConstituencyList] = useState([]);
  const [assemblyList, setAssemblyList] = useState([]);
  const [constituencyId, setConstituencyId] = useState("");
  const [assemblyId, setAssemblyId] = useState("");
  const [extractedData, setExtractedData] = useState(null);

  const OnAssemblySelect = (value) => {
    setAssemblyId(value);
  };

  const OnConstituencySelect = async (value) => {
    setConstituencyId(value);
    setAssemblyId("");
    setAssemblyList([]);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) setAssemblyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleFileData = (data) => {
    setExtractedData(data);
  };

  const handleSubmit = () => {
    if (!assemblyId || !constituencyId) {
      alert("Please select all fields and upload a file");
      return;
    }

    const payload = {
      assembly: assemblyId,
      constituency: constituencyId,
      geogrophicalArea: extractedData.geographicalArea,
      electedCandidate: extractedData.electedCandidate,
      MAP: "images",
    };

    uploadData(payload);
    console.log("Final Payload:", payload);
  };

  const uploadData = async (payload) => {
    const response = await dataService.assemblyAboutUpload(payload);
    if (response.code === 200) {
      message.success("Data uploaded successfully");
    } else {
    }
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setConstituencyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
  }, []);

  return (
    <Card
      title={
        <Title level={4} style={{ textAlign: "center" }}>
          About Assembly Elections
        </Title>
      }
      style={{ width: "100%", maxWidth: 800, margin: "auto", padding: 20 }}
    >
      <Form layout="vertical" style={{ width: "100%" }}>
        <Form.Item label="Select Parliament">
          <Select
            value={constituencyId}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Select Parliament"
            style={{ width: "100%" }}
            onChange={OnConstituencySelect}
          >
            {constituencyList.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.constituencyName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Select Assembly">
          <Select
            value={assemblyId}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Select Assembly"
            style={{ width: "100%" }}
            onChange={OnAssemblySelect}
            disabled={!constituencyId}
          >
            {assemblyList.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.assemblyName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Upload Election Data">
          <AboutElectionsUpload onDataExtracted={handleFileData} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" onClick={handleSubmit} block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default AboutAssembly;
